module.exports = __webpack_public_path__ + "static/media/profile-page-img.373ed11b.jpg";